module.exports = __webpack_public_path__ + "img/device_am35_b.99bb0ca9.png";